import { Icons } from "../../../assets/icons/Icons";

const InvestmentOverview = () => {
    return (
        <div
            className="card mb-4"
            style={{
                border: "1px solid rgba(78, 78, 255, 0.2)",
                borderRadius: "16px",
            }}
        >
            <div className="card-body p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="text-white fs-5 m-0">Investment Overview</h3>

                    <Icons.RoundKabebIcon />
                </div>

                <InvestmentMetric
                    title="Total Investment"
                    value="$19.5k"
                    change="↑ 3.2%"
                    isPositive={true}
                />

                <hr style={{ borderColor: "rgba(255, 255, 255, 0.1)" }} />

                <InvestmentMetric
                    title="Current Balance"
                    value="$51.8k"
                    change="↓ 3.2%"
                    isPositive={false}
                />

                <hr style={{ borderColor: "rgba(255, 255, 255, 0.1)" }} />

                <InvestmentMetric
                    title="Total Withdrawals"
                    value="$72.1k"
                    change="↑ 2%"
                    isPositive={true}
                />

                <BarChart />
            </div>
        </div>
    );
};

const InvestmentMetric = ({ title, value, change, isPositive }) => {
    return (
        <div className="mb-4">
            <div className="d-flex align-items-center mb-2">
                <div
                    className="rounded me-2"
                    style={{
                        width: "16px",
                        height: "16px",
                        backgroundColor: "#8B80F9",
                    }}
                ></div>
                <span className="text-white">{title}</span>
            </div>
            <div className="d-flex align-items-center">
                <h4 className="text-white fs-1 fw-bold mb-0 me-3">{value}</h4>
                <div
                    className="px-2 py-1 rounded"
                    style={{
                        backgroundColor: isPositive
                            ? "rgba(78, 204, 163, 0.2)"
                            : "rgba(220, 53, 69, 0.2)",
                        color: isPositive ? "#4ECCA3" : "#dc3545",
                    }}
                >
                    <span className="small">{change}</span>
                </div>
            </div>
        </div>
    );
};

const BarChart = () => {
    // Data for the bar chart
    const months = ["Jun", "Jul", "Aug", "Sep", "Oct", "Nov"];
    const barHeights = [
        [80, 60, 40],
        [50, 40, 30],
        [60, 45, 20],
        [75, 55, 35],
        [65, 45, 25],
        [45, 35, 25],
    ];

    return (
        <div style={{ height: "200px", marginTop: 50 }}>
            <div className="position-relative h-100">
                {/* Y-axis labels */}
                <div
                    className="position-absolute start-0 h-100 d-flex flex-column justify-content-between"
                    style={{ width: "50px" }}
                >
                    <span className="text-secondary small">$100k</span>
                    <span className="text-secondary small">$75k</span>
                    <span className="text-secondary small">$50k</span>
                    <span className="text-secondary small">$25k</span>
                    <span className="text-secondary small">$0k</span>
                </div>

                {/* Chart area */}
                <div className="ms-5 h-100 d-flex align-items-end justify-content-between">
                    {months.map((month, index) => (
                        <MonthBar
                            key={index}
                            month={month}
                            heights={barHeights[index]}
                        />
                    ))}
                </div>

                {/* Horizontal grid lines */}
                <div className="position-absolute top-0 start-0 end-0 h-100">
                    {[...Array(5)].map((_, index) => (
                        <div
                            key={index}
                            className="border-bottom border-secondary opacity-25"
                            style={{ height: "20%" }}
                        ></div>
                    ))}
                </div>
            </div>
        </div>
    );
};

const MonthBar = ({ month, heights }) => {
    return (
        <div
            className="d-flex flex-column align-items-center"
            style={{ width: "20px" }}
        >
            <div
                className="w-100 rounded-top"
                style={{
                    height: `${heights[0]}px`,
                    backgroundColor: "#8B80F9",
                }}
            ></div>
            <div
                className="w-100"
                style={{
                    height: `${heights[1]}px`,
                    backgroundColor: "#7A6FF8",
                }}
            ></div>
            <div
                className="w-100"
                style={{
                    height: `${heights[2]}px`,
                    backgroundColor: "#6A5FF7",
                }}
            ></div>
            <span className="text-secondary small mt-2">{month}</span>
        </div>
    );
};

export default InvestmentOverview;
